import { isUserLoggedIn } from '../selectors/user';

export const getEmailToPrefill = (state) => {
    const {
        app: {
            user: { email: userEmail } = {},
            inviteEmail,
            campaignToken,
            inviteToken,
            featureFlags: { enableStoredPaymentMethods },
        },
    } = state;

    if ((campaignToken || inviteToken) && inviteEmail) {
        return inviteEmail;
    }

    if (enableStoredPaymentMethods && isUserLoggedIn(state)) {
        return userEmail;
    }

    return false;
};
